import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  IndexPageAction,
  IndexPageConfig,
  IndexPageView,
} from './index-page.model';

@Component({
  selector: 'index-page',
  templateUrl: './index-page.component.html',
  styleUrls: ['./index-page.component.scss'],
})
export class IndexPageComponent {
  @Input() config: IndexPageConfig;

  @Output() viewClicked = new EventEmitter<IndexPageView>();
  @Output() actionClicked = new EventEmitter<{
    view: IndexPageView;
    action: IndexPageAction;
  }>();

  onViewClicked(view: IndexPageView) {
    this.viewClicked.emit(view);
  }

  onActionClicked(action: IndexPageAction, view: IndexPageView) {
    this.actionClicked.emit({ view, action });
  }
}
